/**
 * /devhub/exec-traces — Execution traces (operator). Surface Layer (/01). REQ-001.91 DevHub UI rebuild · Phase 3.
 * Live operator panel (DevHubExecutionTracePanel) wired to its useDevHub* hook over GET /api/control/registry/:name.
 * Operator-only (routePolicy plane guard + DevHubPanelPage self-guard).
 */
import { createFileRoute } from '@tanstack/react-router';
import { DevHubExecutionTracePanel } from '../features/control-plane/DevHubExecutionTracePanel';
import { DevHubPanelPage } from '../components/devhub/DevHubPanelPage';

export const Route = createFileRoute('/devhub/exec-traces')({ component: ExecTracesPage });

function ExecTracesPage() {
  return (
    <DevHubPanelPage
      title="Execution traces"
      subtitle="ReWOO / agent trace events from the local orchestrator."
      status={{ label: 'live', live: true }}
    >
      <DevHubExecutionTracePanel />
    </DevHubPanelPage>
  );
}
